import { render } from "./BlackCat.svg?vue&type=template&id=8d2db7e2"
const script = {}
script.render = render

export default script